import React, {useEffect, useState} from 'react';
import {
	useNavigate,
	useParams,
} from 'react-router-dom';

import {Layout, Page, Text} from '@phonectas/unifon-ui-kit';
import {phoneNumberWithoutSpaces} from 'utils/number';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';
import UserNotFound from './UserNotFound';
import CustomLoader from 'common/components/customLoader';

const RedirectFromBn: React.FC = () => {
	const navigate = useNavigate();
	const params = useParams();
	const {
		getAccount,
		getUser,
		getUpsellUser,
		resetBnRedirect,
	} = useThreeSixtyNewStore((state) => ({
		getAccount: state.getAccount,
		getUser: state.getUser,
		getUpsellUser: state.getUpsellUser,
		resetBnRedirect: state.resetBnRedirect,
	}), shallow);
	const {account, isLoading, accountNotFound, accountUser} = useThreeSixtyNewStore((state) => ({
		account: state.bnRedirect?.account?.id,
		accountNotFound: state.accountNotFound,
		isLoading: state.isLoading,
		accountUser: state.bnRedirect?.account?.account_details?.user_details || null,
	}), shallow);
	const [isDataReady, setIsDataReady] = useState(false);
	const numbParam = typeof params['numb'] === 'string' && params['numb'] ? params['numb'] : undefined;

	useEffect(() => {
		if (!numbParam) return;
		let active = true;
		const phone = phoneNumberWithoutSpaces(numbParam);
		// Drop the previous caller, so nothing navigates on their account or user
		resetBnRedirect();
		setIsDataReady(false);

		getAccount({
			id: null,
			phone,
			onSuccess: () => {
				// Read the store, `account` from this render still holds the previous value
				const accountId = useThreeSixtyNewStore.getState().bnRedirect.account?.id;
				if (!accountId) return;
				// The account was found, so open it also when no user matches the number
				getUser({phone, accountId}).then(() => {
					if (active) setIsDataReady(true);
				});
			},
		});

		return () => {
			active = false;
		};
	}, [getAccount, getUser, resetBnRedirect, numbParam]);

	useEffect(() => {
		if (isDataReady && account) {
			if (accountUser?.user_id) {
				getUpsellUser(accountUser.user_id);
			}
			navigate(`/Unifon360/${account}`);
		}
	}, [isDataReady, account, accountUser, navigate, getUpsellUser]);

	return (
		<Page>
			<Layout fullHeight fullWidth direction="column" nowrap>
				<Layout style={{rowGap: '5px', height: '40px'}} direction="column" fullWidth>
					<Layout fullWidth alignItems="center" nowrap>
						<Text style={{fontSize: '30px'}} variant="h1">Unifon 360</Text>
					</Layout>
				</Layout>
				<CustomLoader advanced isLoading={isLoading} />
				{
					accountNotFound && (
						<Page.Section fullHeight>
							<UserNotFound numb={params['numb'] || ''} />
						</Page.Section>
					)
				}
			</Layout>
		</Page>
	);
}

export default RedirectFromBn;
